import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { JiraLinkedService } from 'app/model/linkedservice/jira.linkedservice';
import { JiraCopySource } from 'app/model/pipeline/copysource/jira.copysource';
import { useEncryptedEndpointsRadioSwitch } from 'app/registries/linked-service/linked-service-shared-fields';
import { format } from 'app/shared/utils/string.util';
import { driverVersionVersionOptions, driverVersions } from '../consts/tabular-consts';
import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { GlobalVariables } from 'app/services/globals';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';

const connectionForm: ControlMetadata[] = [
        {
            type: 'textbox',
            bind: 'host',
            label: stringResources.ModelName_Host,
            required: true,
            placeholder: stringResources.Jira_Host_Placeholder,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'port',
            label: stringResources.ModelName_Port,
            isLabelVertical: true,
            inputType: 'number',
            defaultValue: 443,
            min: 0
        },
        {
            type: 'textbox',
            bind: 'username',
            label: stringResources.ModelName_UserName,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'password',
            label: stringResources.ModelName_Password,
            child: {
                type: 'password',
                label: stringResources.ModelName_Password,
                required: true,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                stringResources.Jira_DisplayText,
                stringResources.ModelName_Password)
        }
    ]

export const jiraMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(JiraLinkedService).name,
    displayName: stringResources.Jira_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-jira'
    },
    isFirstClass: true,
    supportDatasetV2: true,
    category: ['ServicesApps'],
    isDeprecated: GlobalVariables.showLegacy ? undefined : '{ version !== "v2" }',
    copySinkTypes: [],
    showWarningMessage: '{ version !== "v2" }',
    fetchNestedNavTable: true,
    warningMessage: format(
        stringResources.Connector_Legacy_IsNotSupportedWarning_alt5,
            stringResources.VersionLabel.toLocaleLowerCase()),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-jira',
    copySourceTypes: [Metamodel.modelFor(JiraCopySource).name],
    supportCopyJobSource: true,
    SHIRVersion:  {
        v2: '5.61.0.0'
    },
    supportedInTrident: true,
    supportOPDG: GlobalVariables.enableOPDG,
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: 'Jira' as ResourceKind
    },
    controls: 
    [
        {
            type: 'radio-switch',
            isLabelVertical: true,
            label: stringResources.VersionLabel,
            required: true,
            bind: 'version',
            hide: GlobalVariables.showLegacy ? false : '{version === "v2" }',
            options: driverVersionVersionOptions,
            defaultValue: driverVersions.v2,
            cases: [
                {
                    caseValue: driverVersions.v1,
                    children: [
                        {
                            type: 'hint',
                            hintMode: 'warning',
                            description: format(
                                stringResources.Connector_Legacy_IsNotSupportedWarning_alt6,
                                stringResources.VersionLabel.toLocaleLowerCase()),
                            link: 'https://learn.microsoft.com/azure/data-factory/connector-jira'
                        },
                        ...connectionForm,
                        useEncryptedEndpointsRadioSwitch
                    ]
                },
                {
                    caseValue: driverVersions.v2,
                    children: [...connectionForm]
                }
            ]
        },
        ...(connectionForm
            .map((control) => ({
                ...control,
                hide: !GlobalVariables.showLegacy ? '{version !== "v2" }' : true
            }))
        )
    ]
};
